import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import Lazy from '@prisjakt/ui-lazy';

import './article.scss';

const styles = bemGenerator('pj-article', ['preamble', 'byline', 'title']);

const { string, number, bool } = PropTypes;

const Heading = ({ title, embedded }) =>
  embedded ? (
    <h2 className={styles.title}>{title}</h2>
  ) : (
    <h1 className={styles.title}>{title}</h1>
  );

Heading.propTypes = {
  title: string.isRequired,
  embedded: bool,
};
Heading.defaultProps = {
  embedded: false,
};

const Article = props => (
  <article className={styles.block}>
    {props.imageUrl && (
      <figure>
        <Lazy loadOnIdle>
          <img src={props.imageUrl} alt={props.imageCaption} />
        </Lazy>
        {props.imageCaption && <figcaption>{props.imageCaption}</figcaption>}
      </figure>
    )}
    <Heading title={props.title} embedded={props.embedded} />
    {props.preamble && <p className={styles.preamble}>{props.preamble}</p>}
    <div
      dangerouslySetInnerHTML={{
        __html: props.body,
      }}
    />
    {props.byline && <span className={styles.byline}>{props.byline}</span>}
  </article>
);

Article.propTypes = {
  id: number,
  publishedAt: string,
  title: string.isRequired,
  preamble: string,
  byline: string,
  imageUrl: string,
  imageCaption: string,
  body: string.isRequired,
  semanticId: string,
  embedded: bool,
};
Article.defaultProps = {
  id: undefined,
  publishedAt: undefined,
  preamble: undefined,
  byline: undefined,
  imageUrl: undefined,
  imageCaption: undefined,
  semanticId: undefined,
  embedded: true,
};

export default Article;
